export const InteriorDecoratorProductGroup = {
  CurtainPanel: 0,
  CurtainRoomHigh: 1,
  NetCurtainRoomHigh: 2,
  RomanBlind: 3,
  TieBack: 4
};

export const OperatingSide = {
  Left: 0,
  Right: 1
};

export const OperatingType = {
  Manual: 0,
  Electrical: 1
};

export const RomanBlindSubtype = {
  Roman2: 0,
  Roman1: 1,
  Roman2WithoutRail: 2
};

export const RibsEqual = {
  SetBottom: 0,
  SetTop: 1,
  NoSet: 2,
  GapsEqual: 3
};

export const RibType = {
  Tunnel: 0,
  Band: 1
};

export const RomanBlindSystemColor = {
  White: 0,
  Black: 1
};

export const RomanBlindChainColor = {
  White: 0,
  Black: 1,
  Chrome: 2
};

export const RomanBlindRibs = {
  TunnelBack: 0,
  TunnelFront: 1,
  Band: 2
};

export const PleatType = {
  SinglePleat: 0,
  DoublePleat: 1,
  TriplePleat: 2,
  FlatPleat: 3,
  PleatingTape: 4,
  SingleAndReturnPleat: 5,
  DoubleAndReturnPleat: 6
};

export const Fixture = {
  Rail: 0,
  Loop: 1,
  Grommets: 2,
  RodWithRings: 3,
  RodWithSlide: 4,
  RodWithSlideOnSpan: 5,
  Wave: 6
};

export const BottomHem = {
  None: 0,
  Single: 1,
  Double: 2
};

export const Pieces = {
  TwoPieces: 0,
  LeftPiece: 1,
  RightPiece: 2
};

export const TunnelPercentage = {
  Tight: 0,
  Pleated: 1
};

export const EmbraceFinishes = {
  Banana: { Code: 'EMBBANN', TranslationString: 'interiorDecorator.bananaTieback', HeightInCm: 45 },
  Straight: { Code: 'EMBRECHT', TranslationString: 'interiorDecorator.straightTieback', HeightInCm: 30 }
};

export const DefaultBandSizeInCm = 8;
export const CurtainSideHemCorrectionInCm = 14; // Double side hem of 3.5 cm, times two for each side (3.5 * 2 * 2)
export const RomanBlindSideHemCorrectionInCm = 18; // Double side hem of 4.5 cm, times two for each side (4.5 * 2 * 2)
export const PanelStepHalf = 0.5;
export const PanelStepQuarter = 0.25;
export const TunnelAtTopSizeInCm = 10; // Actually equal to bottom tunnel, but 5 cm extra margin is already added separately.
export const TunnelAtBottomSizeInCm = 15;
